<template>
  <div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="goods"
          @selected="handleSelected"
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Goods Receipt' })"
                size="small"
                >{{ $t("inventory.label.CreateItemSale") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create MRN' })"
                size="small"
                >{{ $t("inventory.label.Create_MRN/GRV") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push('/bulkstockupload').catch(() => {})"
                size="small"
                >{{ $t("inventory.label.BulkStockTransfer") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("inventory.label.id") }}</vs-th>
            <vs-th>{{ $t("inventory.label.RequestedDate") }}</vs-th>
            <vs-th>{{ $t("inventory.label.RequestedBy") }}</vs-th>
            <vs-th>{{ $t("inventory.label.RequestFrom") }}</vs-th>
            <vs-th>{{ $t("inventory.label.ItemDescription") }}</vs-th>
            <vs-th>{{ $t("inventory.label.OrderedQuantity") }}</vs-th>
            <vs-th>{{ $t("inventory.label.ReceivedQuantity") }}</vs-th>
            <vs-th>{{ $t("inventory.label.status") }} </vs-th>
            <vs-th class="tHeadCenter">{{ $t("inventory.label.AvailableActions") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="good" v-for="(good, index) in data">
              <vs-td :data="good.id">{{ good.id }}</vs-td>
              <vs-td :data="getDate(good.requestedDate)">{{
                getDate(good.requestedDate)
              }}</vs-td>
              <vs-td :data="good.fromOffice">{{ good.fromOffice }}</vs-td>
              <vs-td :data="good.toOffice">{{ good.toOffice }}</vs-td>
              <vs-td :data="good.itemDescription">{{
                good.itemDescription
              }}</vs-td>
              <vs-td :data="good.orderdQuantity">{{
                good.orderdQuantity
              }}</vs-td>
              <vs-td :data="good.receivedQuantity">{{
                good.receivedQuantity
              }}</vs-td>
              <vs-td :data="good">
                <vs-chip
                  :color="
                    getOrderStatusColor(
                      good.orderdQuantity == good.receivedQuantity
                        ? 'Completed'
                        : 'New'
                    )
                  "
                  class="product-order-status"
                  >{{
                    good.orderdQuantity == good.receivedQuantity
                      ? "Completed"
                      : "New"
                  }}
                </vs-chip>
              </vs-td>
              <vs-td :data="good" class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('inventory.label.MoveItems')"
                    class="icon_row"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    v-show="
                      good.orderdQuantity == good.receivedQuantity
                        ? false
                        : true
                    "
                    @click.stop="mrnData(good)"
                  />
                  <feather-icon
                    icon="PlusCircleIcon"
                    :title="$t('inventory.label.MoveCarton')"
                    class="icon_row"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                    v-show="
                      good.orderdQuantity == good.receivedQuantity
                        ? false
                        : true
                    "
                    @click.stop="moveCartoonData()"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('inventory.label.delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      editJobsPopup = true;
                      delId = good.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('inventory.label.DeleteItemSale')"
          :active.sync="editJobsPopup"
          class="popup-close"
        >
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t("inventory.label.Are_you_sure?")}}</div>
            </div>
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editJobsPopup = false">{{
                $t("inventory.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteTeam(delId)" color="warning">{{
                $t("inventory.label.Ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import {
  viewMRNStockTransfer,
  editGrnTemplate,
  deleteItemSale,
} from "@/http/inventory";
import moment from "moment";
import { mapState } from "vuex";

export default {
  data() {
    return {
      editJobsPopup: false,
      searchOption: 0,
      requestedDate: "",
      editOrderQty: 0,
      saveGrnPayload: {
        requestedDate: "",
        orderdQuantity: "",
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseNo: "",
        supplierId: "",
        officeId: "",
        itemMasterId: "",
      },

      descriptionItems: [5, 10, 15],
      grn: {},
      goods: [],
    };
  },

  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    //   grvData(id) {
    //     this.$router.push(`/movemrn/${id}`);
    //   },

    moveCartoonData(id) {
      this.$router.push({ name: "Move Cartoon Data" });
    },
    handleSelected(good) {
      good.id = good.id.replace(/[{()}]/g, "");
      this.val = good.id.split(" ");
      if (this.val[0] === "MRN") {
        let mrnid = this.val[1];
        let type = "mrn";
        this.$router.push({
          name: "View MRN",
          params: { id: mrnid, type: type },
        });
      } else if (this.val[0] === "GRV") {
        let grvid = this.val[1];
        let type = "grv";
        this.$router.push({
          name: "View GRN",
          params: { id: grvid, type: type },
        });
      } else {
        let saleid = this.val[2];
        let type = "sales";
        this.$router.push({
          name: "View Stock Transfer",
          params: { id: saleid, type: type },
        });
      }
    },

    mrnData(good) {
      good.id = good.id.replace(/[{()}]/g, "");
      this.val = good.id.split(" ");
      if (this.val[0] === "MRN") {
        this.$router.push({ name: "Move MRN", params: { id: this.val[1] } });
      } else if (this.val[0] === "GRV") {
        this.$router.push({ name: "Move GRV", params: { id: this.val[1] } });
      } else {
        this.$router.push({ name: "Move Sales", params: { id: this.val[2] } });
        alert("sale", this.val[2]);
      }
    },
    getOrderStatusColor(status) {
      if (status === "New") return "orange";
      return "success";
    },
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },

    async viewMRNStockTransfer() {
      try {
        const good = await viewMRNStockTransfer();
        this.goods = good.data.pageItems;
      } catch (e) {
        console.log("something went to wrong while contract:", e);
      }
    },

    async deleteTeam(id) {
      try {
        await deleteItemSale(id);
        this.mrnData(good.id[this.val]);
        this.editJobsPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async saveGrn() {
      try {
        // this.editOrderQty = this.grn.orderdQuantity;
        this.saveGrnPayload.purchaseDate = this.getDate(this.grn.purchaseDate);
        this.saveGrnPayload.orderdQuantity = this.editOrderQty;
        this.saveGrnPayload.purchaseNo = this.grn.purchaseNo;
        this.saveGrnPayload.supplierId = this.grn.supplierId;
        this.saveGrnPayload.officeId = this.grn.officeId;
        this.saveGrnPayload.itemMasterId = this.grn.itemMasterId;

        const result = await editGrnTemplate(this.grn.id, this.saveGrnPayload);
        this.editGrnPopup = false;
        this.getGoodsList();
      } catch (e) {
        console.log("something went to wrong while editing the Goods:", e);
      }
    },
  },
  created() {
    this.viewMRNStockTransfer();
  },
  watch: {
    editGrnPopup(newValue) {
      if (newValue) {
        this.viewMRNStockTransfer();
      }
    },
  },
};
</script>
